import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initials',
  standalone: true,
})
export class InitialsPipe implements PipeTransform {
  transform(name: string): string {
    if (!name) return '';
    const words = name.trim().split(/\s+/);
    if (words.length === 0) return '';
    const first = words[0][0]?.toUpperCase() || '';
    const last = words.length > 1 ? words[words.length - 1][0]?.toUpperCase() || '' : '';
    return first + last;
  }
}